import React from "react";
import "./index.css";
import { useDispatch } from "react-redux";
import { setAlert } from "../../../redux/actions/misc";

export default ({ title, icon, back, updateState, step, completed, state, propNames }) => {

    const dispatch = useDispatch();

    return(
        <div className="reference-verification-footer-container">
            <div className="reference-verification-footer-primary-button-container" onClick={() => proceed(completed, step, state, propNames, updateState, dispatch)}>
                <p>{title}</p>
                <img src={icon} alt="" />
            </div>
            <div style={{width: 20, height: 20}}></div>
            {back &&
                <div className="reference-verification-footer-secondary-button-container" onClick={() => updateState(["step"], [step-1], true)}>
                    <p>Previous Step</p>
                </div>
            }
        </div>
    );

}

const proceed = (completed, step, state, propNames, updateState, dispatch) => {

    for (let propName in propNames) {
        if (!state[propNames[propName]]) return dispatch(setAlert("Please fill in required fields.", "error", true));
    }

    if (completed) return updateState(["step", "completed"], [step+1, true], true);

    return updateState(["step"], [step+1], true)

}